/** @format */

import { Component, Input, OnInit } from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconAlertErrorFilled
} from '@dsg-tech/homefield-angular-icons';
import { NgClass, NgStyle, TitleCasePipe } from '@angular/common';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'pdp-personalization-text-input',
	templateUrl: './text-input.component.html',
	styleUrl: './text-input.component.scss',
	imports: [NgClass, NgStyle, HomefieldIconLibraryModule, TitleCasePipe]
})
export class PersonalizationTextInputComponent implements OnInit {
	public TextInputVariants = {
		base: 'base-variant',
		large: 'large-variant'
	};

	@Input()
	public width = '100%';

	@Input()
	public variant = 'base';

	@Input()
	public hasError: boolean;

	@Input()
	public isDisabled: boolean;

	@Input()
	public isRequired: boolean;

	@Input()
	public inputLabel = '';

	@Input()
	public optionalText = '';

	@Input()
	public inlineLabel = '';

	@Input()
	public inputLength: string;

	public attrLabel: string;

	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconAlertErrorFilled]);
	}

	ngOnInit() {
		this.attrLabel = this.getHyphenCaseOfString(this.inputLabel);
	}

	/**
	 * @description Returns the lower and hypen case of a string.
	 */
	private getHyphenCaseOfString(phrase: string): string {
		return phrase.replace(/\s+/g, '-').toLowerCase();
	}
}
